
/**
 * Resource not found
 */
export type NotFoundResponse = void;
